module.exports = __webpack_public_path__ + "img/9788961702676.4608021f.jpg";